module.exports = __webpack_public_path__ + "media/spin.04c7f9d0.webm";